import { StorageData } from "../storage-data";

export interface LoadState {
    isVisible: StorageData<boolean | null, any>;
    wasLogout: boolean;
}

export const INITIAL_STATE: LoadState = {
    isVisible: {
        data: false,
        loading: false,
        error: null
    },
    wasLogout: false
}

export enum LoadActionTypes {
    SET_VISIBLE = '@loading/VISIBLE',
    SET_INVISIBLE = '@loading/INVISIBLE',
}
